// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter-chips{margin:10px 39px}.filter-chips>*{margin:0 5px 5px 5px}", "",{"version":3,"sources":["webpack://./src/app/widgets/FilterChips/FilterChips.scss"],"names":[],"mappings":"AAAA,cACE,gBAAA,CAEA,gBACE,oBAAA","sourcesContent":[".filter-chips{\n  margin: 10px 39px;\n\n  & > *{\n    margin: 0 5px 5px 5px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
